import React from 'react';
import PropTypes from 'prop-types';
import {getModelForResourceType} from 'resources/modelRegistry';
import moment from 'moment';

import {Card, Text, Badge} from '@albert-io/atomic';
import {renderMoment} from 'lib/timeUtils';

const PersonalSubscriptionCard = ({subscription}) => {
  const active = moment().isBetween(subscription.getStartDate(), subscription.getEndDate());

  return (
    <Card
      border='none'
      className='subscriptions-card u-pad_4 u-mar-b_2 u-display_flex u-align-items_flex-start'
    >
      <Badge color={active ? 'success' : 'emphasized'} className='u-mar-r_7'>
        {active ? 'Active' : 'Expired'}
      </Badge>
      <div className='subscriptions-card__subscriptions-metadata u-display_flex u-flex-direction_column u-justify-content_space-between u-flex-grow_1'>
        <div className='subscriptions-card__subscriptions-metadata__metadata-item u-mar-r_2 u-display_flex u-flex-direction_column'>
          <Text bold size='xs' emphasis='high' className='u-mar-b_1'>
            Subjects included:
          </Text>
          <Text size='xs' emphasis='high'>
            {subscription.getSubject().getName()}
          </Text>
        </div>
        <div className='subscriptions-card__subscriptions-metadata__metadata-item u-mar-r_2 u-display_flex u-flex-direction_column'>
          <Text bold size='xs' emphasis='high' className='u-mar-b_1'>
            Purchased:
          </Text>
          <Text size='xs' emphasis='high'>
            {renderMoment(subscription.getStartDate(), 'date')}
          </Text>
        </div>
        <div className='subscriptions-card__subscriptions-metadata__metadata-item u-display_flex u-flex-direction_column'>
          <Text bold size='xs' emphasis='high' className='u-mar-b_1'>
            Expiration:
          </Text>
          <Text size='xs' emphasis='high'>
            {renderMoment(subscription.getEndDate(), 'date')}
          </Text>
        </div>
      </div>
    </Card>
  );
};

PersonalSubscriptionCard.propTypes = {
  subscription: PropTypes.instanceOf(getModelForResourceType('subscription_v1'))
};

export default PersonalSubscriptionCard;
